module.exports = __webpack_public_path__ + "static/media/320x100_0004_ru.fc326aa2.jpg";